import { render } from "./WCCouponRow.vue?vue&type=template&id=1020a750&scoped=true"
import script from "./WCCouponRow.vue?vue&type=script&lang=js"
export * from "./WCCouponRow.vue?vue&type=script&lang=js"

import "./WCCouponRow.vue?vue&type=style&index=0&id=1020a750&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1020a750"]])

export default __exports__